import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';
import { useWorkspaceUsers } from '@/hooks/api/0150_workspace_users';
import { useProducts } from '@/hooks/api/0390_products';
import { useSalesContexts } from '@/hooks/api/2130_sales_contexts';
import { useMenuListedTeams } from '@/hooks/api/2260_menu_listed_teams';

export const SearchConditionTags = () => {
  const { _w_ } = useCurrentWorkspace();
  const { salesOrdersDashboardSearchCondition: searchCondition } = useDashboardSearchCondition();
  const { data: users } = useWorkspaceUsers({ identifier: _w_!.identifier });
  const { data: teams } = useMenuListedTeams({ identifier: _w_!.identifier });
  const { data: products } = useProducts({ identifier: _w_!.identifier });
  const { data: salesContexts } = useSalesContexts();
  const isConditionExist = Object.values(searchCondition)
    .flat()
    .some((v) => v);

  if (!isConditionExist) return <></>;

  return (
    <div className="d-flex mb-4 align-items-center flex-wrap">
      {teams &&
        teams.purchase_order_teams
          .filter((d) => searchCondition.team_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {salesContexts &&
        salesContexts
          .filter((d) => searchCondition.sales_context_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}
      {products &&
        products
          .filter((d) => searchCondition.product_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {users &&
        users
          .filter((d) => searchCondition.user_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.user_account.name}
            </span>
          ))}
    </div>
  );
};
